import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { LegacyPaymentCallbackRedirect } from './modules/payments/pages/LegacyPaymentCallbackRedirect';
import { AppUpdateRequired } from './pages/AppUpdateRequired';

// Create Sentry-wrapped Routes component
const SentryRoutes = Sentry.withSentryRouting(Routes);

const AppRoutes = () => (
  <SentryRoutes>
    {/* Legacy callback URLs: redirect to API so callback logic runs there */}
    <Route
      path="/payments/callback/success"
      element={<LegacyPaymentCallbackRedirect status="success" />}
    />
    <Route
      path="/payments/callback/failure"
      element={<LegacyPaymentCallbackRedirect status="failure" />}
    />

    {/* All other routes: app version is deprecated */}
    <Route path="*" element={<AppUpdateRequired />} />
  </SentryRoutes>
);

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
